import { toClassName } from '../../../utils/toClassName';
import styles from './Clickable.module.css';

const Clickable = ({ children, className, onClick, ...restProps }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={toClassName(styles.container, className)}
      {...restProps}>
      {children}
    </button>
  );
};
export default Clickable;
